module.exports = __webpack_public_path__ + "img/scrubbing_splash.1cf5aed0.jpg";